import { en } from '@nuxt/ui/locale'
import { defineLocale } from '#ui/composables'
import type { Messages } from '@nuxt/ui'

export const mi = defineLocale<Messages>({
  // 1. Copy the metadata from English
  ...en,
  name: 'Te Reo Māori',
  code: 'mi',
  // 2. Spread the English messages, then override with your Māori ones
  messages: {
    ...en.messages,
    commandPalette: {
      placeholder: 'Rapua...',
      noMatch: 'Kāore i kitea tētahi kōrero e rite ana',
      noData: 'Kāore he raraunga',
      close: 'Katia',
      back: 'Hoki'
    },
    selectMenu: {
      ...en.messages.selectMenu,
      noMatch: 'Kāore i kitea'
    }
    // Any property you don't list here will just use the 'en' version
  }
})
